import { Link, useLocation } from 'react-router-dom';
import { CompassIcon } from 'lucide-react';
import { NotFoundView } from './NotFoundView';
import { btnPrimary, btnSecondary } from './styles';
import { adminNav } from '../adminNav';
import { ADMIN_BASE } from '../../utils/hosts';

/**
 * Een adres in het beheer dat niet bestaat. Was vroeger stil het overzicht, waardoor een oude
 * bladwijzer of typfout leek te werken. Nu: zeggen wat er is, en het dichtstbijzijnde onderdeel
 * voorstellen ("/be/klant/12" → Klanten) naast de weg naar het overzicht.
 */
export function AdminNotFound() {
  const {
    pathname
  } = useLocation();
  const section = closestSection(pathname);
  return <NotFoundView icon={CompassIcon} title="Deze pagina staat niet in het beheer" text={section ? `Misschien is de link veranderd. Bedoelde je ${section.label}?` : 'Misschien is de link veranderd, of komt hij uit een oude bladwijzer. Alles wat je zocht staat in het menu.'} path={pathname} actions={<>
          {section && <Link to={section.to} className={btnPrimary} data-id="element-4898" data-mp="1gwg18a1u8xoe">
              Naar {section.label}
            </Link>}
          <Link to={ADMIN_BASE} className={section ? btnSecondary : btnPrimary} data-id="element-4899" data-mp="1qodcfgsujpn4">
            Naar het overzicht
          </Link>
        </>} data-id="element-4897" data-mp="1xpwgv7z8xjfr" />;
}

/** Het menu-onderdeel waarvan het eerste stuk van het pad het meest lijkt op wat er getypt is. */
function closestSection(pathname: string) {
  const segment = pathname.slice(ADMIN_BASE.length).split('/').filter(Boolean)[0]?.toLowerCase();
  if (!segment) return undefined;
  const candidates = adminNav.filter(n => n.to !== ADMIN_BASE);
  const slug = (to: string) => to.slice(ADMIN_BASE.length + 1);
  // Eerst exact of begin ("klant" → klanten, "product" → producten), dan andersom ("instellingenx").
  return candidates.find(n => slug(n.to).startsWith(segment)) ?? candidates.find(n => segment.startsWith(slug(n.to)));
}